import { render, staticRenderFns } from "./CheckboxInputBlock.vue?vue&type=template&id=27ec0894"
import script from "./CheckboxInputBlock.vue?vue&type=script&lang=ts"
export * from "./CheckboxInputBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports